
<!--  video player modal -->
<div class="modal fade" id="videoPlayer" tabindex="-1" role="dialog" aria-labelledby="videoPlayer" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <button class="no-border-btn doc-close-btn" data-dismiss="modal" (click)="onCloseVideo()">
        <img src="../../../../assets/images/cross-icon-3.svg" alt="cross-icon" width="24px" height="24px">
      </button>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 details content-center">
            <div class="video">
                <video controls (click)="toggleVideo($event)" #videoPlayer width="700px" height="350px" >
                    <source [src]="videoSource" alt="video" type="video/mp4"/>
                    Browser not supported
                </video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>